
export default function PlatformSection() {
  return (
    <section id="platform" className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold border-l-4 border-teal-500 pl-4 mb-10">
          Podcast & Media Appearances
        </h2>
        
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">Featured Conversations</h3>
            <p className="text-lg text-gray-700">
              Alberto regularly appears on leading podcasts and media outlets to discuss the intersection of AI ethics, human behavior, and the future of decision-making. His insights on the Consistency Paradox have sparked conversations across industries.
            </p>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <i className="ri-mic-line text-teal-600 text-xl"></i>
                <span className="text-gray-700">Available for podcast interviews</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-tv-line text-teal-600 text-xl"></i>
                <span className="text-gray-700">Media commentary on AI ethics</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-article-line text-teal-600 text-xl"></i>
                <span className="text-gray-700">Expert analysis and opinion pieces</span>
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/799cd65fa118e6fba18d3267ad8738aa.jpg"
              alt="Podcast and Media Setup" 
              className="rounded-xl shadow-lg object-top"
            />
          </div>
        </div>

        {/* Recent Appearances */}
        <div className="space-y-8">
          <h3 className="text-2xl font-bold text-gray-900">Recent Media Highlights</h3>
          <div className="grid md:grid-cols-3 gap-8">
            
            <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-teal-500">
              <div className="flex items-center space-x-3 mb-4">
                <i className="ri-radio-line text-teal-600 text-2xl"></i>
                <h4 className="text-lg font-bold">Tech Ethics Today</h4>
              </div>
              <p className="text-gray-700 mb-3">
                "The Consistency Paradox: Why AI Makes Better Moral Decisions"
              </p>
              <p className="text-sm text-gray-500">Featured Episode • 45 minutes</p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-teal-500">
              <div className="flex items-center space-x-3 mb-4">
                <i className="ri-newspaper-line text-teal-600 text-2xl"></i>
                <h4 className="text-lg font-bold">AI Business Weekly</h4>
              </div>
              <p className="text-gray-700 mb-3">
                "How Corporations Can Learn from AI's Ethical Consistency"
              </p>
              <p className="text-sm text-gray-500">Cover Story • Print & Digital</p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-teal-500">
              <div className="flex items-center space-x-3 mb-4">
                <i className="ri-live-line text-teal-600 text-2xl"></i>
                <h4 className="text-lg font-bold">Future of Work Summit</h4>
              </div>
              <p className="text-gray-700 mb-3">
                "Panel: AI as Mirror - Reflecting Human Decision-Making Flaws"
              </p>
              <p className="text-sm text-gray-500">Keynote Panel • Live Stream</p>
            </div>

          </div>
        </div>

        {/* Media Kit CTA */}
        <div className="mt-12 text-center">
          <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-teal-500 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Media Inquiries Welcome</h3>
            <p className="text-lg text-gray-700 mb-6">
              Interested in having Alberto on your podcast or media outlet? Download our media kit or get in touch directly.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 justify-center">
              <button className="bg-teal-500 hover:bg-teal-600 text-white font-semibold py-3 px-6 rounded-full transition-colors whitespace-nowrap cursor-pointer">
                Download Media Kit
              </button>
              <button className="bg-gray-700 hover:bg-gray-600 text-white font-semibold py-3 px-6 rounded-full transition-colors whitespace-nowrap cursor-pointer">
                Schedule Interview
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
